import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { StoreService } from './store.service';
import { Md5 } from 'ts-md5/dist/md5';
import { of } from 'rxjs';
import Swal from 'sweetalert2';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class SharedService {
  today = new Date();
  weeklyScheduleReady: Promise<void> = Promise.resolve();
  startTime!: number;
  restaurantSchedule: any;
  restaurantData: any;
  restaurantDish: any;
  selected_policy: any;
  restaurant_status: any;

  // res_vat_rate: number;
  // res_vat_type: string;

  constructor(
    private store: StoreService,
    @Inject(PLATFORM_ID) private readonly platformId: any
  ) {
    if (this.platformId === 'browser') {
      this.store.restaurantData.subscribe(res => {
        if (Object.getOwnPropertyNames(res).length !== 0) {
          if(sessionStorage.getItem('fullSchedule')){
            const fullScheduleStr = sessionStorage.getItem('fullSchedule');
            if (!fullScheduleStr) return;
              const fullScheduleData = JSON.parse(fullScheduleStr);
              this.restaurantSchedule = fullScheduleData;
          }
          // this.restaurantSchedule = res.restaurant_data['schedule'];
          this.restaurantData = res.restaurant_data;
          // this.res_vat_rate = Number((res.restaurant_data['vat_rate'] !== null ? res.restaurant_data['vat_rate'] : 0).toFixed(2));
          // this.res_vat_type = res.restaurant_data['is_vat_included'] === true ? 'include' : 'exclude';
        }
      });
      this.store.restaurantMenu.subscribe(res => {
        if (Object.getOwnPropertyNames(res).length !== 0) {
          this.restaurantDish = res['dishes_information'];
        }
      });
      if (sessionStorage.getItem('policy')) {
        const policyStr = sessionStorage.getItem('policy');
        if (policyStr) {
          this.selected_policy = JSON.parse(policyStr).policy;
        }
      }
    }
  }

  public async newOrderingScheduleProcessing(selectedPolicy: string = this.selected_policy, scheduleData: any, processingFrom?: string): Promise<void> {
    if (processingFrom !== 'from_cart') {
      await this.weeklyScheduleReady;
    }
    let counter: number = 0;
    let preOrderColTimes: any = [];
    let preOrderDelTimes: any = [];
    let rawScheduleData : any;

    let collectionEnabled = false;
    let deliveryEnabled = false;
    let reservationEnabled = false;
    let firstCollectionMetaSet = false;
    let firstDeliveryMetaSet = false;


    if(processingFrom === 'from_cart') {
      // showing (saved) scheduleData when schedule processing from cart for CERTAIN INTERVAL schedule setting etc 
      // because when we calling newOrderingScheduleProcessing from cart, we don't have full schedule data we have only byDateData or byDayData (which is already modified)
      rawScheduleData = scheduleData;
    }else{
      rawScheduleData = scheduleData?.byDateData ? scheduleData?.byDateData : scheduleData.byDayData;
    }

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const midnightCutoffMinutes = 4 * 60; // mid night cut off time 4:00 AM

    // A cart kept open across midnight already has the carry-over shifts attached.
    if (processingFrom === 'from_cart' && currentMinutes < midnightCutoffMinutes &&
        rawScheduleData?.shift?.some((shift: any) => shift?._isNextDayShift)) {
      rawScheduleData = {
        ...rawScheduleData,
        isMidNightShift: false,
        shift: rawScheduleData.shift
          .filter((shift: any) => shift?._isNextDayShift)
          .map((shift: any) => ({ ...shift, _isNextDayShift: false }))
      };
    }

    if (processingFrom !== 'from_cart') {
      let fullSchedule = this.restaurantSchedule;

      if (this.platformId === 'browser') {
        const fullWeekStr = sessionStorage.getItem('fullweekschedule');
        if (fullWeekStr) {
          fullSchedule = JSON.parse(fullWeekStr);
        } else if (!fullSchedule) {
          const fullScheduleStr = sessionStorage.getItem('fullSchedule');
          if (fullScheduleStr) {
            fullSchedule = JSON.parse(fullScheduleStr);
          }
        }
      }

      const scheduleDayOfWeek = rawScheduleData?.dayOfWeek ?? now.getDay();
      const prevDayOfWeek = (scheduleDayOfWeek + 6) % 7;
      const nextDayOfWeek = (scheduleDayOfWeek + 1) % 7;

      const prevDaySchedule = Array.isArray(fullSchedule)
        ? fullSchedule.find((day: any) => day?.dayOfWeek === prevDayOfWeek)
        : null;
      const nextDaySchedule = Array.isArray(fullSchedule)
        ? fullSchedule.find((day: any) => day?.dayOfWeek === nextDayOfWeek)
        : null;

      const isBeforeCutoff = currentMinutes < midnightCutoffMinutes;

      if (isBeforeCutoff && prevDaySchedule?.isMidNightShift && rawScheduleData?.shift?.length > 0) {
        const carryOverShift = rawScheduleData.shift[0];
        rawScheduleData = {
          ...prevDaySchedule,
          shift: [carryOverShift],
          isMidNightShift: false
        };
      } else if (!isBeforeCutoff && rawScheduleData?.isMidNightShift && nextDaySchedule?.shift?.length > 0 && Array.isArray(rawScheduleData?.shift)) {
        const nextDayShift = nextDaySchedule.shift[0];
        const alreadyMerged = rawScheduleData.shift.some((shift: any) => shift?._id && nextDayShift?._id && shift._id === nextDayShift._id);

        if (nextDayShift && !alreadyMerged) {
          rawScheduleData = {
            ...rawScheduleData,
            shift: [...rawScheduleData.shift, { ...nextDayShift, _isNextDayShift: true }]
          };
        }
      }
    }

    if (this.platformId === 'browser') {
      sessionStorage.setItem('rawSchedule', JSON.stringify(rawScheduleData))
    }
    if (!rawScheduleData && !this.restaurantData) {
      return;
    }
    /*
     @add custom schdeule handling code here
    */
    let myOrderingSchedule: any = {
      restaurantStatus: (this.restaurantData?.is_ordering === false || this.restaurantData?.restaurant_mode !== 1) ? 'CLOSED' : rawScheduleData?.isActive ? 'OPEN' : 'CLOSED',
      orderingStatus: 'CLOSED',
      isDelivery: this.restaurantData?.is_delivery_closed_for_today ? false : this.restaurantData.is_delivery,
      isCollection: this.restaurantData?.is_collection_closed_for_today ? false : this.restaurantData.is_collection,
      isOrdering: this.restaurantData?.is_ordering,
      isReservation: this.restaurantData?.is_reservation,
      opening_hours: '',
      collection_startTime: '',
      delivery_startTime: '',
      preOrderCollecitonTimes: [],
      preOrderDeliveryTimes: [],
      orderingMode: { collection: 'NONE', delivery: 'NONE' }, // asap, pre, none
      openShiftIndex: null
    }

    let isCollectionPreOrderChangeable = true;

    if (this.restaurantData && myOrderingSchedule?.isOrdering && rawScheduleData?.isActive && rawScheduleData.shift.length > 0) {
      rawScheduleData.shift.forEach((scheduleItem: any, index: number) => {
        counter = counter + 1;
        if (scheduleItem) {
          const shiftOffsetMinutes = scheduleItem?._isNextDayShift ? 24 * 60 : 0;
          const openingMinutes = this.getMinutes(scheduleItem.openingTime) + shiftOffsetMinutes;
          const closingMinutes = this.getMinutes(scheduleItem.closingTime) + shiftOffsetMinutes;
          const collectionStartMinutes = this.getMinutes(scheduleItem.collection.startTime) + shiftOffsetMinutes;
          const collectionEndMinutes = this.getMinutes(scheduleItem.collection.endTime) + shiftOffsetMinutes;
          const deliveryStartMinutes = this.getMinutes(scheduleItem.delivery.startTime) + shiftOffsetMinutes;
          const deliveryEndMinutes = this.getMinutes(scheduleItem.delivery.endTime) + shiftOffsetMinutes;
          const reservationStartMinutes = scheduleItem.reservation?.startTime
            ? this.getMinutes(scheduleItem.reservation.startTime) + shiftOffsetMinutes
            : null;
          const reservationEndMinutes = scheduleItem.reservation?.endTime
            ? this.getMinutes(scheduleItem.reservation.endTime) + shiftOffsetMinutes
            : null;

          myOrderingSchedule.opening_hours = myOrderingSchedule.opening_hours.concat(` (${this.convertTime24to12(scheduleItem.openingTime)} - ${this.convertTime24to12(scheduleItem.closingTime)}) `);
          if (currentMinutes >= openingMinutes && currentMinutes <= closingMinutes) {
            // OPEN
            myOrderingSchedule.openShiftIndex = index;
            myOrderingSchedule.orderingStatus = 'ASAP';
            myOrderingSchedule.restaurantStatus = 'OPEN';
            myOrderingSchedule.collection_startTime = scheduleItem.collection.startTime;
            myOrderingSchedule.delivery_startTime = scheduleItem.delivery.startTime;
            myOrderingSchedule.isCollection = false;
            myOrderingSchedule.isDelivery = false;

            
            if (this.restaurantData.is_collection) {
              if (!this.restaurantData?.is_collection_closed_for_today && currentMinutes >= collectionStartMinutes && currentMinutes <= collectionEndMinutes && scheduleItem.collection.isActive) {
                myOrderingSchedule.isCollection = true;
                myOrderingSchedule.orderingMode.collection = 'ASAP';
                let collectionTime = scheduleItem.collection.collectionTime;
                isCollectionPreOrderChangeable = false;
                /*OVERRIDE TIME WITH EXTEND collection TIME*/
                if (this.restaurantData?.is_collection_time_extended) {
                  collectionTime = this.restaurantData?.default_collection_time
                }


                preOrderColTimes = [...preOrderColTimes, ...scheduleItem.collection.timeList]; // merge times
                myOrderingSchedule = Object.assign({}, myOrderingSchedule, { collectionTime: collectionTime, minCollectionAmount: scheduleItem.collection.minCollectionAmount, preOrderCollecitonTimes: scheduleItem.collection.timeList });
              } else if (!this.restaurantData?.is_collection_closed_for_today && currentMinutes < collectionStartMinutes && currentMinutes < collectionEndMinutes && scheduleItem.collection.isActive) {
                myOrderingSchedule.isCollection = true;
                myOrderingSchedule.orderingMode.collection = 'PRE-ORDER';
                let collectionTime = scheduleItem.collection.collectionTime;
                /*OVERRIDE TIME WITH EXTEND collection TIME*/
                if (this.restaurantData?.is_collection_time_extended) {
                  collectionTime = this.restaurantData?.default_collection_time
                }

                preOrderColTimes = [...preOrderColTimes, ...scheduleItem.collection.timeList]; // merge times
                myOrderingSchedule = Object.assign({}, myOrderingSchedule, { collectionTime: collectionTime, minCollectionAmount: scheduleItem.collection.minCollectionAmount, preOrderCollecitonTimes: scheduleItem.collection.timeList });


              } 
            } else {
              //COLLECTION IS DISABLED FROM RESTAURANT SETTING
              myOrderingSchedule.orderingMode.collection = 'NONE';
              myOrderingSchedule.isCollection = false;
            }

            if (this.restaurantData.is_delivery) {
              if (!this.restaurantData?.is_delivery_closed_for_today && currentMinutes >= deliveryStartMinutes && currentMinutes <= deliveryEndMinutes && scheduleItem.delivery.isActive) {
                myOrderingSchedule.isDelivery = true;
                myOrderingSchedule.orderingMode.delivery = 'ASAP';
                let deliveryTime = scheduleItem.delivery.deliveryTime;
                /*OVERRIDE TIME WITH EXTEND delivery TIME*/
                if (this.restaurantData?.is_delivery_time_extended) {
                  deliveryTime = this.restaurantData?.default_delivery_time
                }

                preOrderDelTimes = [...preOrderDelTimes, ...scheduleItem.delivery.timeList];
                myOrderingSchedule = Object.assign({}, myOrderingSchedule, { deliveryTime: deliveryTime, minDeliveryAmount: scheduleItem.delivery.minDeliveryAmount, preOrderDeliveryTimes: scheduleItem.delivery.timeList });
              }
              else if (!this.restaurantData?.is_delivery_closed_for_today && currentMinutes < deliveryStartMinutes && currentMinutes < deliveryEndMinutes && scheduleItem.delivery.isActive) {
                myOrderingSchedule.isDelivery = true;
                myOrderingSchedule.orderingMode.delivery = 'PRE-ORDER';
                let deliveryTime = scheduleItem.delivery.deliveryTime;
                /*OVERRIDE TIME WITH EXTEND delivery TIME*/
                if (this.restaurantData?.is_delivery_time_extended) {
                  deliveryTime = this.restaurantData?.default_delivery_time
                }

                preOrderDelTimes = [...preOrderDelTimes, ...scheduleItem.delivery.timeList];
                myOrderingSchedule = Object.assign({}, myOrderingSchedule, { deliveryTime: deliveryTime, minDeliveryAmount: scheduleItem.delivery.minDeliveryAmount, preOrderDeliveryTimes: scheduleItem.delivery.timeList });
              }
            }else {
              myOrderingSchedule.orderingMode.delivery = 'NONE';
              myOrderingSchedule.isDelivery = false;
            }

            if (this.restaurantData.is_reservation) {
              if (reservationStartMinutes !== null && reservationEndMinutes !== null && currentMinutes >= reservationStartMinutes && currentMinutes <= reservationEndMinutes && scheduleItem.reservation.isActive) {
                myOrderingSchedule.isReservation = true;
              }
              else if (reservationStartMinutes !== null && reservationEndMinutes !== null && currentMinutes < reservationStartMinutes && currentMinutes < reservationEndMinutes && scheduleItem.reservation.isActive) {
                myOrderingSchedule.isReservation = true;
              }
              else {
                myOrderingSchedule.isReservation = false;
              }
            } else {
              myOrderingSchedule.isReservation = false;
            }
          } else {
            if(this.restaurantData?.is_collection){
              if(!this.restaurantData?.is_collection_closed_for_today && (scheduleItem?.collection?.isActive && currentMinutes < collectionStartMinutes)){
                preOrderColTimes = [...preOrderColTimes, ...scheduleItem.collection.timeList];
                myOrderingSchedule.isCollection = true;
                myOrderingSchedule.orderingMode.collection = myOrderingSchedule.orderingMode.collection === 'NONE' ? 'PRE-ORDER' : myOrderingSchedule.orderingMode.collection;
                myOrderingSchedule = Object.assign({}, myOrderingSchedule, { collectionTime: this.restaurantData?.is_collection_time_extended ? this.restaurantData?.default_collection_time : scheduleItem.collection.collectionTime, minCollectionAmount: scheduleItem.collection.minCollectionAmount });
              }
            }
            if(this.restaurantData?.is_delivery){
              if(!this.restaurantData?.is_delivery_closed_for_today && (scheduleItem?.delivery?.isActive && currentMinutes < deliveryStartMinutes)){
                preOrderDelTimes = [...preOrderDelTimes, ...scheduleItem.delivery.timeList];
                myOrderingSchedule.isDelivery = true;
                myOrderingSchedule.orderingMode.delivery = myOrderingSchedule.orderingMode.delivery === 'NONE' ? 'PRE-ORDER' : myOrderingSchedule.orderingMode.delivery;
                myOrderingSchedule = Object.assign({}, myOrderingSchedule, { deliveryTime: this.restaurantData?.is_delivery_time_extended ? this.restaurantData?.default_delivery_time : scheduleItem.delivery.deliveryTime, minDeliveryAmount: scheduleItem.delivery.minDeliveryAmount });
              }
            }
            myOrderingSchedule.restaurantStatus = myOrderingSchedule.orderingStatus === 'ASAP' ? 'OPEN' : 'PRE-ORDER';
            myOrderingSchedule.orderingStatus = myOrderingSchedule.orderingStatus === 'ASAP' ? myOrderingSchedule.orderingStatus : 'PRE-ORDER';

            if (myOrderingSchedule?.restaurantStatus !== 'OPEN') {
              if (currentMinutes < openingMinutes) {

                // Save the first upcoming shift index only once
                if (myOrderingSchedule.openShiftIndex === null) {
                  myOrderingSchedule.openShiftIndex = index;
                  // collection start time is always the first upcoming shift's collection start
                  myOrderingSchedule.collection_startTime = scheduleItem.collection.startTime;

                  // delivery start time -> first upcoming shift with delivery active
                  let deliveryStart = null;
                  for (let d = index; d < rawScheduleData.shift.length; d++) {
                    if (rawScheduleData.shift[d].delivery?.isActive) {
                      deliveryStart = rawScheduleData.shift[d].delivery.startTime;
                      break;
                    }
                  }
                  myOrderingSchedule.delivery_startTime = deliveryStart;
                }

                myOrderingSchedule.restaurantStatus =
                  myOrderingSchedule.orderingStatus === 'ASAP' ? 'OPEN' : 'PRE-ORDER';

                myOrderingSchedule.orderingStatus =
                  myOrderingSchedule.orderingStatus === 'ASAP'
                    ? myOrderingSchedule.orderingStatus
                    : 'PRE-ORDER';

                // ------------ COLLECTION: accumulate, do NOT overwrite false -> true ------------
                if (this.restaurantData.is_collection) {
                  // Pre-order collection is valid only if collection isn't closed for today and current < shift collection start
                  if (!this.restaurantData?.is_collection_closed_for_today && currentMinutes < collectionStartMinutes && scheduleItem.collection.isActive) {
                    // Mark collection available
                    collectionEnabled = true;
                    myOrderingSchedule.isCollection = true;

                    // Set collection meta fields only once (first active future collection shift)
                    if (!firstCollectionMetaSet) {
                      myOrderingSchedule = Object.assign({}, myOrderingSchedule, {
                        collectionTime: this.restaurantData?.is_collection_time_extended
                          ? this.restaurantData?.default_collection_time
                          : scheduleItem.collection.collectionTime,
                        minCollectionAmount: scheduleItem.collection.minCollectionAmount,
                      });
                      firstCollectionMetaSet = true;
                    }

                    // Merge future collection time list
                    preOrderColTimes = [...preOrderColTimes, ...scheduleItem.collection.timeList];
                  } else {
                    // don't set orderingMode.collection = 'NONE' here — wait until after loop
                    myOrderingSchedule.isCollection = false;
                  }
                }

                // ------------ DELIVERY: accumulate, do NOT overwrite false -> true ------------
                if (this.restaurantData.is_delivery) {
                  // For delivery pre-order: if delivery is active for this future shift, collect it
                  if (!this.restaurantData?.is_delivery_closed_for_today && scheduleItem.delivery?.isActive) {
                    deliveryEnabled = true;
                    myOrderingSchedule.isDelivery = true;

                    // Set delivery meta fields only once (first active future delivery shift)
                    if (!firstDeliveryMetaSet) {
                      myOrderingSchedule = Object.assign({}, myOrderingSchedule, {
                        deliveryTime: this.restaurantData?.is_delivery_time_extended
                          ? this.restaurantData?.default_delivery_time
                          : scheduleItem.delivery.deliveryTime,
                        minDeliveryAmount: scheduleItem.delivery.minDeliveryAmount,
                      });
                      firstDeliveryMetaSet = true;
                    }

                    // Merge delivery times
                    preOrderDelTimes = [...preOrderDelTimes, ...scheduleItem.delivery.timeList];
                  } else {
                    // If this shift's delivery is inactive, do not overwrite previously set deliveryEnabled
                    // but still allow future shifts to add to preOrderDelTimes (handled above when active)
                    myOrderingSchedule.isDelivery = false;
                  }
                }

                // ------------ RESERVATION: accumulate similarly ------------
                if (this.restaurantData.is_reservation) {
                  if (reservationStartMinutes !== null && currentMinutes < reservationStartMinutes && scheduleItem.reservation?.isActive) {
                    reservationEnabled = true;
                  }
                }
              } else {
                if (rawScheduleData.shift.length === counter) {
                  myOrderingSchedule.isOrdering = false;
                  myOrderingSchedule.restaurantStatus = 'CLOSED'
                }
                myOrderingSchedule.isCollection = false;
                myOrderingSchedule.isDelivery = false;
                myOrderingSchedule.isReservation = false;
              }
            }
          }

          const uniqueTimesPreOrderColTimes: any[] = [...new Set(preOrderColTimes)];
          const uniqueTimesPreOrderDeliveryTimes: any[] = [...new Set(preOrderDelTimes)];
          myOrderingSchedule.preOrderCollecitonTimes = uniqueTimesPreOrderColTimes;
          myOrderingSchedule.preOrderDeliveryTimes = uniqueTimesPreOrderDeliveryTimes;
        }
      });
      
    }
    if (rawScheduleData?.status === 'closed') {
      myOrderingSchedule.restaurantStatus = 'CLOSED';
      myOrderingSchedule.isReservation = false;
      myOrderingSchedule.isDelivery = false;
      myOrderingSchedule.isOrdering = false;
      myOrderingSchedule.isCollection = false;
    }

    if (this.platformId === 'browser') {
      sessionStorage.setItem('todaysSchedule', JSON.stringify(myOrderingSchedule))
    }
    this.store.saveSchedule(myOrderingSchedule); //redux store
  }

  getCurrentShiftDetails(shiftList: any) {
    // Get current time in "HH:MM" format
    const now = new Date();
    const currentTime = `${this.pad(now.getHours())}:${this.pad(now.getMinutes())}`;

    // Find the shift based on current time
    const currentShift = shiftList.find((shift: any) => {
      return this.isTimeWithinRange(currentTime, shift.openingTime, shift.closingTime);
    });

    if (currentShift) {
      return {
        shiftName: currentShift.shiftName,
        timeRangeType: currentShift.delivery.timeRangeType,
        timeSlotGap: currentShift.delivery.timeSlotGap,
        timeRangeGap: currentShift.delivery.timeRangeGap
      };
    } else {
      return {
        shiftName: '',
        timeRangeType: '',
        timeSlotGap: '',
        timeRangeGap: ''
      };
    }
  }

  pad(num: number): string {
    return num.toString().padStart(2, '0');
  }

  // footer schedule data 
  // formattedFullSchedule(data: any) {
  //   const formattedData = data.map((day: any) => ({
  //     dayOfWeek: day.dayOfWeek,
  //     dayName: day.dayName,
  //     status: day.status,
  //     scheduleType: day.scheduleType,
  //     isActive: day.isActive,
  //     shift: day.shift.map((shift: any) => ({
  //       shiftName: shift.shiftName,
  //       isActive: shift?.reservation?.isActive,
  //       openingTime: this.convertTime24to12(shift.openingTime),
  //       closingTime: this.convertTime24to12(shift.closingTime),
  //       timeList: shift?.reservation?.timeList
  //     }))
  //   }));
  //   return formattedData;
  // }

  
  // this full schedule works for reservation 
  formattedFullSchedule(data: any) {
    const formattedData = data.map((day: any) => {
      // Include shifts where any service (collection, delivery, or reservation) is active
      const activeShifts = day?.shift.filter((shift: any) =>
        shift?.collection?.isActive || shift?.delivery?.isActive || shift?.reservation?.isActive
      );

      // Determine if any reservation is active
      const isReservationActive = day.shift.some((shift: any) => shift?.reservation?.isActive);
  
      return {
        dayOfWeek: day?.dayOfWeek,
        dayName: day?.dayName,
        status: day?.status,
        scheduleType: day?.scheduleType,
        label: day?.label,
        isActive: day?.isActive,
        isReservationActive: isReservationActive,
        shift: activeShifts.map((shift: any) => ({
          shiftName: shift?.shiftName,
          isActive: shift?.reservation?.isActive,
          openingTime: this.convertTime24to12(shift?.openingTime),
          closingTime: this.convertTime24to12(shift?.closingTime),
          timeList: shift?.reservation?.timeList
        }))
      };
    });
  
    return formattedData;
  }

  // this formatted schedule works for footer  
  formattedFooterSchedule(data: any) {
    const formattedData = data.map((day: any) => {
  
      return {
        dayOfWeek: day?.dayOfWeek,
        dayName: day?.dayName,
        status: day?.status,
        scheduleType: day?.scheduleType,
        isActive: day?.isActive,
        shift: day?.shift.map((shift: any) => ({
          shiftName: shift?.shiftName,
          openingTime: this.convertTime24to12(shift?.openingTime),
          closingTime: this.convertTime24to12(shift?.closingTime),
        }))
      };
    });
  
    return formattedData;
  }

  isTimeWithinRange(currentTime: string, openingTime: string, closingTime: string): boolean {
    return currentTime >= openingTime && currentTime <= closingTime;
  }
  validateUserSelectedTime(): void {
    if (this.platformId === 'browser') {
      if (sessionStorage.getItem('policy')) {
        let currentTime = new Date();
        const currentDate = new Date();
        const policyStr = sessionStorage.getItem('policy');
        if (!policyStr) return;
        let userSelectedTimeObject = JSON.parse(policyStr);
        this.selected_policy = userSelectedTimeObject;
        // this.scheduleProcessing(this.selected_policy.policy);
        const userTimeDate = this.getOrderTimeDate(userSelectedTimeObject.when, userSelectedTimeObject.policy, userSelectedTimeObject.res_status);
        /**
         * IF TIME ALREADY PASSED AWAY
         * AND USER BACK TO PLACE ORDER
        */
        if (currentTime >= new Date(userTimeDate)) {
          /**
           * As time is gone, re-generate schedule
           * **/

          if (userSelectedTimeObject.status === 'ASAP') {
            currentDate.setMinutes(new Date().getMinutes() + Number(userSelectedTimeObject.delivery_time));
            //const time = currentDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
            const time = this.convertTime24to12(currentDate.toTimeString().substring(0, 5));
            userSelectedTimeObject.when = time;
            this.store.saveSelectedPolicy(userSelectedTimeObject);
            sessionStorage.setItem('policy', JSON.stringify(userSelectedTimeObject));
          }

        } else {
          /**
           * - USER IN TIME
           * - FIND HOW LONG HAVE PASSED 
           * - IF PASSWED MAX NUM OF TIME
           * - check schdeule policy time in num 
           * - RE-ASSIGN ASAP TIME AUTOMATICALLY
           * 
          */

          let difference = new Date(userTimeDate).getTime() - currentTime.getTime(); // This will give difference in milliseconds
          let resultInMinutes = Math.round(difference / 60000);
          const policyData = JSON.parse(policyStr);
          if (resultInMinutes < policyData.delivery_time) {
            if (userSelectedTimeObject.status === 'ASAP') {
              currentDate.setMinutes(new Date().getMinutes() + Number(userSelectedTimeObject.delivery_time));
              //const time = currentDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
              const time = this.convertTime24to12(currentDate.toTimeString().substring(0, 5))
              userSelectedTimeObject.when = time;
              this.store.saveSelectedPolicy(userSelectedTimeObject);
              sessionStorage.setItem('policy', JSON.stringify(userSelectedTimeObject));
            }
          }

        }
      }
    }
  }

  setDeliveryTime(timeObject: any): void {
    let time = {
      status: timeObject.status === 'OPEN' ? 'ASAP' : 'PRE-ORDER',
      when: timeObject.asap ? timeObject.asap : timeObject.today[0].time,
      res_status: timeObject.status
    }
    this.store.storeDeliveryTime(time);
    if (this.platformId === 'browser') {
      sessionStorage.setItem('time', JSON.stringify(time));
    }
  }

  convertTime24to12 = (time24: any) => {
    const [sHours, minutes] = time24.match(/([0-9]{1,2}):([0-9]{2})/).slice(1);
    const period = +sHours < 12 ? 'AM' : 'PM';
    const hours = +sHours % 12 || 12;

    return `${hours}:${minutes} ${period}`;
  }
  convertTime12to24 = (time12: any) => {
    const [sHours, minutes, period] = time12.match(/([0-9]{1,2}):([0-9]{2}) (AM|PM|am|pm)/).slice(1);
    const PM = period === 'PM';
    const hours = (+sHours % 12) + (PM ? 12 : 0);

    return `${('0' + hours).slice(-2)}:${minutes}`;
  }

  getMinutes(time24h: any) {
    var time = time24h.split(':');
    return time[0] * 60 + time[1] * 1;
  }

  getMinutesNow() {
    var timeNow = new Date();
    let time = timeNow.getHours() * 60 + timeNow.getMinutes();
    return time;
  }

  isToday(date: any) {
    const today = new Date();
    if (today.toDateString() === date.toDateString()) {
      return true;
    }
    return false;
  }

  hoursToMinutes(hours: number) {
    if (hours) {
      return (hours * 60);
    }
    return 0;
  }

  public BookingScheduleProcessing(date: string, advanceHours?: number, timeGap?: number, fullSchedule?: any) {
    if(fullSchedule){
      this.restaurantSchedule = fullSchedule ? fullSchedule : this.restaurantSchedule;
    }
    let selectedDate = new Date(date)
    return new Promise((resolve, reject) => {
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const dayName = days[new Date(selectedDate).getDay()];
      if ((this.restaurantSchedule && this.restaurantSchedule.length > 0) && this.restaurantData['is_reservation']) {
        const schedule = this.restaurantSchedule.find((f: any) => f.dayName === dayName);
        if (schedule?.status === 'closed') {
          let _msg = "<strong>The restaurant is closed for selected date.</strong> <br>Please contact with restaurant if you have any inquiry";
          resolve({ status: 'CLOSED', msg: _msg });
          return false;
        }
        if (schedule?.isReservationActive === false) {
          let _msg = "<strong>The restaurant is closed for selected date.</strong> <br>Please contact with restaurant if you have any inquiry";
          resolve({ status: 'CLOSED', msg: _msg });
          return false;
        }
        if (!schedule) {
          let _msg = "<strong>it\'s a holiday, You can select another date</strong> <br>Please contact with restaurant if you have any inquiry";
          resolve({ status: 'CLOSED', msg: _msg });
          return false;
        }
        const safeAdvanceHours = advanceHours || 0;
        let now: number = this.isToday(selectedDate) ? (this.getMinutesNow() + this.hoursToMinutes(safeAdvanceHours)) : 0;
        if (now >= 1440) {
          let _msg = advanceHours ? `You have to book before ${advanceHours} hours ago.` : 'We are fully book today.';
          resolve({ status: 'CLOSED', msg: _msg });
          return false;
        }
        let timesArray: any[] = [];
        let filteredTimes : any;
        schedule['shift'].forEach((schedule: any, index: any) => {
          if (!schedule.timeList) return false;

          let opening_time24 = this.convertTime12to24(schedule['openingTime']);
          let closing_time24 = this.convertTime12to24(schedule['closingTime']);

          let start = this.getMinutes(opening_time24);
          let end = this.getMinutes(closing_time24);
          if (now < end) {
            timesArray = [...timesArray, ...schedule.timeList];
          }
        });

        let min = this.hoursToMinutes(safeAdvanceHours);
        let currentDate = new Date(new Date().setMinutes(new Date().getMinutes() + min));

        filteredTimes = timesArray.filter((item: any) => {
        const timeDate = this.convertToDate(item?.time);
        return timeDate > currentDate;
        });

        const formatSelectedDate = new Date(date).setHours(0, 0, 0, 0)
        const formatTodayDate = new Date().setHours(0, 0, 0, 0)

        if(formatSelectedDate === formatTodayDate){
          resolve(filteredTimes);
        }else{
          resolve(timesArray);
        }

      } else {
        reject(null);
      }
    });
  }


  private generateTimeList(opening: any, closing: any, gapTime: number = 15) {
    const start = new Date(opening);
    const end = new Date(closing);
    let minutesArray: any[] = [];
    for (let i = 0; i < 60; i++) {
      if ((gapTime * i) > 60) break;
      minutesArray.push(gapTime * i);
    }

    const newMinutes = minutesArray.find(item => item >= start.getMinutes());
    start.setMinutes(newMinutes);

    var arr = [];
    while (start <= end) {
      let time = this.convertTime24to12(start.toTimeString().substring(0, 5))
      arr.push(time);
      start.setMinutes(start.getMinutes() + gapTime);
    }
    return arr;
  }

  public changeTimeFormat(date: any) {
    // IT CONVERTS TO 24 HOUR TIME FORMATE TO 12 HOUR TIME FORMAT
    const h = date.getHours();
    let m = date.getMinutes();
    m = ('0' + m).slice(-2);
    let _time = '';
    if (h >= 12) {
      _time = (h > 12) ? ('0' + (h - 12)).slice(-2) + ':' + m + ' ' + 'PM' : ('0' + h).slice(-2) + ':' + m + ' ' + 'PM';
    } else {
      _time = ('0' + h).slice(-2) + ':' + m + ' ' + 'AM';
    }
    return _time;
  }

  checkPromotionEligibility(totalAmount: any, discountsData: any, offersData: any) {
    /*  Default = 1
     Only Collection = 2
     Only Delivery = 3
     Both (Collection & Delivery) = 4
     First Order = 5
     Cash Only = 6
     Card = 7
     others = 8*/

    return new Promise(resolve => {
      const currentTime = this.today;
      let offers: any[] = [];
      let discount: any[] = [];
      if (this.platformId === 'browser') {
        let selected_policy: any;
        let user: any;
        let selected_payment: any;
        let convertedWhenTime : any;
        let res_status: any;
        /*@Override@*/
        this.store.selected_policy.subscribe((result: any) => {
          if (result && result['policy']) {
            convertedWhenTime = this.getOrderTimeDate(result?.when, result?.policy, result?.res_status);
            selected_policy = result['policy'] === 'COLLECTION' ? 1 : 2;
            res_status = result?.res_status;
          } else {
            selected_policy = 2;
          }
        });
        this.store.user.subscribe((result: any) => {
          if (result && result['isLogged'] === true) {
            user = result['data'];
          }
        });
        this.store.paymentMethod.subscribe((result: any) => {
          if (result && result['is_active']) {
            // selected_payment = result['paymentType'] === 'CARD' ? 2 : 1
            if(result['paymentType'] === 'CARD'){
              selected_payment = 2;
            }
            if(result['paymentType'] === 'CASH'){
              selected_payment = 1;
            }
            if(result['paymentType'] === 'Pay by card on delivery/collection' || result['paymentType']?.includes('Pay by card')){
              selected_payment = 3;
            }
          }
        });
        setTimeout(() => {
          if (offersData.length > 0) {
            /**
             * COLLECTION AND DELIVERY BOTH= 0
             * COLLECTION = 1
             * DELIVERY = 2
             * **/
            const offData = offersData.filter((item: any) =>
              item?.its_type === 2
              && totalAmount >= item.offer_eligible_amount
              && item.is_active === true
              && (item.platform === 0 || item.platform === 1 || item.platform === 4 || item.platform === 5)
            );

            if (offData.length > 0) {
              offData.forEach((item: any) => {
                if (Number(item.offer_eligible_for) === selected_policy || Number(item.offer_eligible_for) === 0) {
                  /**
                   * - CHECK ELIGIBLE PAYMENT METHODS CASH = 1, CARD = 2, BOTH = 0
                   * - CHECK DISCOUNT START DATE AND END DATE IF NO DATE FIXED THEN IT'S FOR ALL DAY
                   * - CHECK DISCOUNT AVAILABLE TIMES
                   * - CHECK DEFAULT (AUTOMATIC ACCEPT DISCOUNT)
                   * - CHECK IS IT FIRST ORDER BY CUSTOMER
                   * **/

                  if (selected_payment) {
                    if (item.eligible_payment_methods === selected_payment || item.eligible_payment_methods === 0) {
                      /*
                        * - EITHER CASH OR CARD * CASH = 1; CARD = 2
                        * */

                      if (item.start_date !== null && item.end_date !== null) {
                        /**
                         * - IF START AND END DATE ASSIGNED
                         */
                        const start_date = new Date(item.start_date);
                        const end_date = new Date(item.end_date);
                        if (currentTime >= start_date && currentTime <= end_date) {
                          if (item.offer_available_time.length > 0) {
                            const dayName = currentTime.getDay();
                            const _times = item.offer_available_time.filter((book: any) => book.day_name === dayName);
                            if (_times.length > 0) {
                              const start_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].start_time));
                              const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].end_time));
                              // if (currentTime >= start_time && currentTime <= end_time || currentTime < start_time) {
                              if ((currentTime >= start_time && currentTime <= end_time) || ((currentTime >= start_time && convertedWhenTime >= start_time) && (currentTime <= end_time && convertedWhenTime <= end_time))) {
                                // if (item.is_default) {
                                //   /*** - COUNT USER PREVIOUS ORDERS * **/
                                //   if (item.is_first_order && (user && user.total_orders === 0)) {
                                //     offers.push(item);
                                //   }

                                //   if (item.is_first_order === false) {
                                //     offers.push(item);
                                //   }
                                //   // default discount added directly
                                //   if (!sessionStorage.getItem('promoId')) {
                                //     this.store.saveAcceptedPromotion(item);
                                //   }
                                // } 
                                
                                // NEW CODE WITH FIRST ORDER 
                                if (item.is_default) {
                                  if (item.is_first_order && user?.total_orders === 0) {
                                    if (!sessionStorage.getItem('promoId')) {
                                      offers.push(item);
                                      this.store.saveAcceptedPromotion(item);
                                    }
                                  } else if (!item.is_first_order) {
                                    if (!sessionStorage.getItem('promoId')) {
                                      offers.push(item);
                                      this.store.saveAcceptedPromotion(item);
                                    }
                                  }
                                }

                                else { 
                                  /**
                                   * - NOT DEFAULT
                                   * - USER HAVE TO ACCEPT DISCOUNT
                                   * **/

                                  if (item.is_first_order && (user && user.total_orders === 0)) {
                                    offers.push(item);
                                  }

                                  if (item.is_first_order === false) {
                                    offers.push(item);
                                  }
                                }
                              }
                            } // end time compare
                          } else {
                            /**
                             * - NOT TIME GIVEN
                             * **/
                            // if (item.is_default) {
                            //   /*** - COUNT USER PREVIOUS ORDERS * **/
                            //   if (item.is_first_order && (user && user.total_orders === 0)) {
                            //     offers.push(item);
                            //   }

                            //   if (item.is_first_order === false) {
                            //     offers.push(item);
                            //   }
                            //   // default discount added directly
                            //   if (!sessionStorage.getItem('promoId')) {
                            //     this.store.saveAcceptedPromotion(item);
                            //   }
                            // } 
                            // NEW CODE WITH FIRST ORDER 
                            if (item.is_default) {
                              if (item.is_first_order && user?.total_orders === 0) {
                                if (!sessionStorage.getItem('promoId')) {
                                  offers.push(item);
                                  this.store.saveAcceptedPromotion(item);
                                }
                              } else if (!item.is_first_order) {
                                if (!sessionStorage.getItem('promoId')) {
                                  offers.push(item);
                                  this.store.saveAcceptedPromotion(item);
                                }
                              }
                            }
                            
                            else {
                              /**
                               * - NOT DEFAULT * - USER HAVE TO ACCEPT DISCOUNT
                               * **/

                              if (item.is_first_order && (user && user.total_orders === 0)) {
                                offers.push(item);
                              }

                              if (item.is_first_order === false) {
                                offers.push(item);
                              }
                            }
                          }
                        }
                      } else {
                        /*
                          * - IF START AND END DATE NOT GIVEN.
                          * */
                        if (item.offer_available_time.length > 0) {
                          const dayName = currentTime.getDay();
                          const _times = item.offer_available_time.filter((book: any) => book.day_name === dayName);
                          if (_times.length > 0) {
                            const start_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].start_time));
                            const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].end_time));
                            // if (currentTime >= start_time && currentTime <= end_time || currentTime < start_time) {
                            if ((currentTime >= start_time && currentTime <= end_time) || ((currentTime >= start_time && convertedWhenTime >= start_time) && (currentTime <= end_time && convertedWhenTime <= end_time))) {
                              // if (item.is_default) {
                              //   /*** - COUNT USER PREVIOUS ORDERS * **/
                              //   if (item.is_first_order && (user && user.total_orders === 0)) {
                              //     offers.push(item);
                              //   }

                              //   if (item.is_first_order === false) {
                              //     offers.push(item);
                              //   }
                              //   // default discount added directly
                              //   if (!sessionStorage.getItem('promoId')) {
                              //     this.store.saveAcceptedPromotion(item);
                              //   }
                              // } 
                              // NEW CODE WITH FIRST ORDER 
                              if (item.is_default) {
                                if (item.is_first_order && user?.total_orders === 0) {
                                  if (!sessionStorage.getItem('promoId')) {
                                    offers.push(item);
                                    this.store.saveAcceptedPromotion(item);
                                  }
                                } else if (!item.is_first_order) {
                                  if (!sessionStorage.getItem('promoId')) {
                                    offers.push(item);
                                    this.store.saveAcceptedPromotion(item);
                                  }
                                }
                              }
                              else {
                                /**
                                 * - NOT DEFAULT
                                 * - USER HAVE TO ACCEPT DISCOUNT
                                 * **/

                                if (item.is_first_order && (user && user.total_orders === 0)) {
                                  offers.push(item);
                                }

                                if (item.is_first_order === false) {
                                  offers.push(item);
                                }
                              }
                            }
                          } // end time compare
                        } else {
                          // if (item.is_default) {
                          //   /**
                          //    * - COUNT USER PREVIOUS ORDERS
                          //    * **/
                          //   if (item.is_first_order && (user && user.total_orders === 0)) {
                          //     offers.push(item);
                          //   }

                          //   if (item.is_first_order === false) {
                          //     offers.push(item);
                          //   }
                          //   // default discount added directly
                          //   if (!sessionStorage.getItem('promoId')) {
                          //     this.store.saveAcceptedPromotion(item);
                          //   }
                          // }
                          // NEW CODE WITH FIRST ORDER 
                          if (item.is_default) {
                            if (item.is_first_order && user?.total_orders === 0) {
                              if (!sessionStorage.getItem('promoId')) {
                                offers.push(item);
                                this.store.saveAcceptedPromotion(item);
                              }
                            } else if (!item.is_first_order) {
                              if (!sessionStorage.getItem('promoId')) {
                                offers.push(item);
                                this.store.saveAcceptedPromotion(item);
                              }
                            }
                          }
                           else {
                            /**
                             * - NOT DEFAULT
                             * - USER HAVE TO ACCEPT DISCOUNT
                             * **/

                            if (item.is_first_order && (user && user.total_orders === 0)) {
                              offers.push(item);
                            }

                            if (item.is_first_order === false) {
                              offers.push(item);
                            }
                          }
                        }
                      }
                    }
                  } else {
                    /**
                     * - IF USER DID NOT SELECT PAYMENT METHOD YET!
                     * **/

                    /*
                      * - EITHER CASH OR CARD * CASH = 1; CARD = 2
                      * */

                    if (item.start_date !== null && item.end_date !== null) {
                      /**
                       * - IF START AND END DATE ASSIGNED
                       */
                      const start_date = new Date(item.start_date);
                      const end_date = new Date(item.end_date);
                      if (currentTime >= start_date && currentTime <= end_date) {
                        if (item.offer_available_time.length > 0) {
                          const dayName = currentTime.getDay();
                          const _times = item.offer_available_time.filter((book: any) => book.day_name === dayName);
                          if (_times.length > 0) {
                            const start_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].start_time));
                            const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].end_time));
                            // if (currentTime >= start_time && currentTime <= end_time || currentTime < start_time) {
                            if ((currentTime >= start_time && currentTime <= end_time) || ((currentTime >= start_time && convertedWhenTime >= start_time) && (currentTime <= end_time && convertedWhenTime <= end_time))) {
                              // if (item.is_default) {
                              //   /*** - COUNT USER PREVIOUS ORDERS * **/
                              //   if (item.is_first_order && (user && user.total_orders === 0)) {
                              //     offers.push(item);
                              //   }

                              //   if (item.is_first_order === false) {
                              //     offers.push(item);
                              //   }
                              //   // default discount added directly
                              //   if (!sessionStorage.getItem('promoId')) {
                              //     this.store.saveAcceptedPromotion(item);
                              //   }
                              // } 
                              // NEW CODE WITH FIRST ORDER 
                              if (item.is_default) {
                                if (item.is_first_order && user?.total_orders === 0) {
                                  if (!sessionStorage.getItem('promoId')) {
                                    offers.push(item);
                                    this.store.saveAcceptedPromotion(item);
                                  }
                                } else if (!item.is_first_order) {
                                  if (!sessionStorage.getItem('promoId')) {
                                    offers.push(item);
                                    this.store.saveAcceptedPromotion(item);
                                  }
                                }
                              }
                              else {
                                /**
                                 * - NOT DEFAULT
                                 * - USER HAVE TO ACCEPT DISCOUNT
                                 * **/

                                if (item.is_first_order && (user && user.total_orders === 0)) {
                                  offers.push(item);
                                }

                                if (item.is_first_order === false) {
                                  offers.push(item);
                                }
                              }
                            }
                          } // end time compare
                        } else {
                          /**
                           * - NOT TIME GIVEN
                           * **/
                          // if (item.is_default) {
                          //   /*** - COUNT USER PREVIOUS ORDERS * **/
                          //   if (item.is_first_order && (user && user.total_orders === 0)) {
                          //     offers.push(item);
                          //   }

                          //   if (item.is_first_order === false) {
                          //     offers.push(item);
                          //   }
                          //   // default discount added directly
                          //   if (!sessionStorage.getItem('promoId')) {
                          //     this.store.saveAcceptedPromotion(item);
                          //   }
                          // }
                          // NEW CODE WITH FIRST ORDER 
                          if (item.is_default) {
                            if (item.is_first_order && user?.total_orders === 0) {
                              if (!sessionStorage.getItem('promoId')) {
                                offers.push(item);
                                this.store.saveAcceptedPromotion(item);
                              }
                            } else if (!item.is_first_order) {
                              if (!sessionStorage.getItem('promoId')) {
                                offers.push(item);
                                this.store.saveAcceptedPromotion(item);
                              }
                            }
                          }
                           else {
                            /**
                             * - NOT DEFAULT * - USER HAVE TO ACCEPT DISCOUNT
                             * **/

                            if (item.is_first_order && (user && user.total_orders === 0)) {
                              offers.push(item);
                            }

                            if (item.is_first_order === false) {
                              offers.push(item);
                            }
                          }
                        }
                      }
                    } else {
                      /*
                        * - IF START AND END DATE NOT GIVEN.
                        * */
                      if (item.offer_available_time.length > 0) {
                        const dayName = currentTime.getDay();
                        const _times = item.offer_available_time.filter((book: any) => book.day_name === dayName);
                        if (_times.length > 0) {
                          const start_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].start_time));
                          const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].end_time));
                          // if (currentTime >= start_time && currentTime <= end_time || currentTime < start_time) {
                          if ((currentTime >= start_time && currentTime <= end_time) || ((currentTime >= start_time && convertedWhenTime >= start_time) && (currentTime <= end_time && convertedWhenTime <= end_time))) {
                            // if (item.is_default) {
                            //   /*** - COUNT USER PREVIOUS ORDERS * **/
                            //   if (item.is_first_order && (user && user.total_orders === 0)) {
                            //     offers.push(item);
                            //   }

                            //   if (item.is_first_order === false) {
                            //     offers.push(item);
                            //   }
                            //   // default discount added directly
                            //   if (!sessionStorage.getItem('promoId')) {
                            //     this.store.saveAcceptedPromotion(item);
                            //   }
                            // }
                            // NEW CODE WITH FIRST ORDER 
                            if (item.is_default) {
                              if (item.is_first_order && user?.total_orders === 0) {
                                if (!sessionStorage.getItem('promoId')) {
                                  offers.push(item);
                                  this.store.saveAcceptedPromotion(item);
                                }
                              } else if (!item.is_first_order) {
                                if (!sessionStorage.getItem('promoId')) {
                                  offers.push(item);
                                  this.store.saveAcceptedPromotion(item);
                                }
                              }
                            }
                             else {
                              /**
                               * - NOT DEFAULT
                               * - USER HAVE TO ACCEPT DISCOUNT
                               * **/

                              if (item.is_first_order && (user && user.total_orders === 0)) {
                                offers.push(item);
                              }

                              if (item.is_first_order === false) {
                                offers.push(item);
                              }
                            }
                          }
                        } // end time compare
                      } else {
                        // if (item.is_default) {
                        //   /**
                        //    * - COUNT USER PREVIOUS ORDERS
                        //    * **/
                        //   if (item.is_first_order && (user && user.total_orders === 0)) {
                        //     offers.push(item);
                        //   }

                        //   if (item.is_first_order === false) {
                        //     offers.push(item);
                        //   }
                        //   // default discount added directly
                        //   if (!sessionStorage.getItem('promoId')) {
                        //     this.store.saveAcceptedPromotion(item);
                        //   }
                        // } 
                        // NEW CODE WITH FIRST ORDER 
                        if (item.is_default) {
                          if (item.is_first_order && user?.total_orders === 0) {
                            if (!sessionStorage.getItem('promoId')) {
                              offers.push(item);
                              this.store.saveAcceptedPromotion(item);
                            }
                          } else if (!item.is_first_order) {
                            if (!sessionStorage.getItem('promoId')) {
                              offers.push(item);
                              this.store.saveAcceptedPromotion(item);
                            }
                          }
                        }
                        else {
                          /**
                           * - NOT DEFAULT
                           * - USER HAVE TO ACCEPT DISCOUNT
                           * **/

                          if (item.is_first_order && (user && user.total_orders === 0)) {
                            offers.push(item);
                          }

                          if (item.is_first_order === false) {
                            offers.push(item);
                          }
                        }
                      }
                    }
                  }
                } else {
                  offers = [];
                  this.store.saveAcceptedPromotion({});
                }
              });
            }
          }

          if (discountsData.length > 0) {
            /**
             * COLLECTION AND DELIVERY BOTH= 0
             * COLLECTION = 1
             * DELIVER = 2
             * **/
            const dis = discountsData.filter((item: any) =>
              item?.its_type === 1
              && totalAmount >= item.discount_eligible_amount
              && item.is_active === true
              && (item.platform === 0 || item.platform === 1 || item.platform === 4 || item.platform === 5)
            );
            if (dis.length > 0) {

              dis.forEach((item: any) => {
                if (Number(item.discount_eligible_for) === selected_policy || Number(item.discount_eligible_for) === 0) {
                  /**
                   * - CHECK ELIGIBLE PAYMENT METHODS CASH = 1, CARD = 2, BOTH = 0
                   * - CHECK DISCOUNT START DATE AND END DATE IF NO DATE FIXED THEN IT'S FOR ALL DAY
                   * - CHECK DISCOUNT AVAILABLE TIMES
                   * - CHECK DEFAULT (AUTOMATIC ACCEPT DISCOUNT)
                   * - CHECK IS IT FIRST ORDER BY CUSTOMER
                   * **/

                  if (selected_payment) {
                    if (item.eligible_payment_methods === selected_payment || item.eligible_payment_methods === 0) {
                      /*
                        * - EITHER CASH OR CARD * CASH = 1; CARD = 2
                        * */

                      if (item.start_date !== null && item.end_date !== null) {
                        /**
                         * - IF START AND END DATE ASSIGNED
                         */
                        const start_date = new Date(item.start_date);
                        const end_date = new Date(item.end_date);
                        if (currentTime >= start_date && currentTime <= end_date) {

                          if (item.discount_available_time.length > 0) {

                            const dayName = currentTime.getDay();
                            const _times = item.discount_available_time.filter((book: any) => book.day_name === dayName);
                            if (_times.length > 0) {
                              const start_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].start_time));
                              const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].end_time));
                              
                              // if (currentTime >= start_time && currentTime <= end_time || currentTime < start_time) {
                              if ((currentTime >= start_time && currentTime <= end_time) || ((currentTime >= start_time && convertedWhenTime >= start_time) && (currentTime <= end_time && convertedWhenTime <= end_time))) {
                                // if (item.is_default) {

                                //   /*** - COUNT USER PREVIOUS ORDERS * **/
                                //   if (item.is_first_order && (user && user.total_orders === 0)) {
                                //     discount.push(item);
                                //   }
                                //   if (item.is_first_order === false) {
                                //     discount.push(item);
                                //   }
                                //   // default discount added directly
                                //   if (!sessionStorage.getItem('promoId')) {
                                //     this.store.saveAcceptedPromotion(item);
                                //   }
                                // } 
                                // NEW CODE WITH FIRST ORDER 
                                if (item.is_default) {
                                if (item.is_first_order && user?.total_orders === 0) {
                                  if (!sessionStorage.getItem('promoId')) {
                                    discount.push(item);
                                    this.store.saveAcceptedPromotion(item);
                                  }
                                } else if (!item.is_first_order) {
                                  if (!sessionStorage.getItem('promoId')) {
                                    discount.push(item);
                                    this.store.saveAcceptedPromotion(item);
                                  }
                                }
                              }
                              else {
                                  /**
                                   * - NOT DEFAULT
                                   * - USER HAVE TO ACCEPT DISCOUNT
                                   * **/

                                  /*** - COUNT USER PREVIOUS ORDERS * **/
                                  if (item.is_first_order && (user && user.total_orders === 0)) {
                                    discount.push(item);
                                  }
                                  if (item.is_first_order === false) {
                                    discount.push(item);
                                  }
                                }
                              } // end time compare
                            }
                          } else {
                            /**
                             * - NOT TIME GIVEN
                             * **/
                            // if (item.is_default) {
                            //   /*** - COUNT USER PREVIOUS ORDERS * **/
                            //   /*** - COUNT USER PREVIOUS ORDERS * **/
                            //   if (item.is_first_order && (user && user.total_orders === 0)) {
                            //     discount.push(item);
                            //   }
                            //   if (item.is_first_order === false) {
                            //     discount.push(item);
                            //   }
                            //   // default discount added directly
                            //   if (!sessionStorage.getItem('promoId')) {
                            //     this.store.saveAcceptedPromotion(item);
                            //   }
                            // } 
                            // NEW CODE WITH FIRST ORDER 
                            if (item.is_default) {
                                if (item.is_first_order && user?.total_orders === 0) {
                                  if (!sessionStorage.getItem('promoId')) {
                                    discount.push(item);
                                    this.store.saveAcceptedPromotion(item);
                                  }
                                } else if (!item.is_first_order) {
                                  if (!sessionStorage.getItem('promoId')) {
                                    discount.push(item);
                                    this.store.saveAcceptedPromotion(item);
                                  }
                                }
                              }
                            
                            else {
                              /**
                               * - NOT DEFAULT * - USER HAVE TO ACCEPT DISCOUNT
                               * **/


                              /*** - COUNT USER PREVIOUS ORDERS * **/
                              if (item.is_first_order && (user && user.total_orders === 0)) {
                                discount.push(item);
                              }
                              if (item.is_first_order === false) {
                                discount.push(item);
                              }
                            }
                          }
                        }
                      } else {
                        /*
                          * - IF START AND END DATE NOT GIVEN (if it is NULL).
                          * - PROCESS WITH TIME ELSE DEFAULT
                          * */

                        if (item.discount_available_time.length > 0) {
                          const dayName = currentTime.getDay();
                          const _times = item.discount_available_time.filter((book: any) => book.day_name === dayName);
                          if (_times.length > 0) {
                            const start_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].start_time));
                            const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].end_time));
                            // if (currentTime >= start_time && currentTime <= end_time || currentTime < start_time) {
                            if ((currentTime >= start_time && currentTime <= end_time) || ((currentTime >= start_time && convertedWhenTime >= start_time) && (currentTime <= end_time && convertedWhenTime <= end_time))) {
                              // if (item.is_default) {
                              //   /*** - COUNT USER PREVIOUS ORDERS * **/
                              //   if (item.is_first_order && (user && user.total_orders === 0)) {
                              //     discount.push(item);
                              //   }
                              //   if (item.is_first_order === false) {
                              //     discount.push(item);
                              //   }
                              //   // default discount added directly
                              //   if (!sessionStorage.getItem('promoId')) {
                              //     this.store.saveAcceptedPromotion(item);
                              //   }

                              // }
                              // NEW CODE WITH FIRST ORDER 
                              if (item.is_default) {
                                  if (item.is_first_order && user?.total_orders === 0) {
                                    if (!sessionStorage.getItem('promoId')) {
                                      discount.push(item);
                                      this.store.saveAcceptedPromotion(item);
                                    }
                                  } else if (!item.is_first_order) {
                                    if (!sessionStorage.getItem('promoId')) {
                                      discount.push(item);
                                      this.store.saveAcceptedPromotion(item);
                                    }
                                  }
                                }
                               else {
                                /**
                                 * - NOT DEFAULT
                                 * - USER HAVE TO ACCEPT DISCOUNT
                                 * **/

                                /*** - COUNT USER PREVIOUS ORDERS * **/
                                if (item.is_first_order && (user && user.total_orders === 0)) {
                                  discount.push(item);
                                }
                                if (item.is_first_order === false) {
                                  discount.push(item);
                                }
                              }
                            }
                          } // end time compare
                        } else {
                          // if (item.is_default) {
                          //   /**
                          //    * - COUNT USER PREVIOUS ORDERS
                          //    * **/
                          //   /*** - COUNT USER PREVIOUS ORDERS * **/
                          //   if (item.is_first_order && (user && user.total_orders === 0)) {
                          //     discount.push(item);
                          //   }
                          //   if (item.is_first_order === false) {
                          //     discount.push(item);
                          //   }
                          //   // default discount added directly
                          //   if (!sessionStorage.getItem('promoId')) {
                          //     this.store.saveAcceptedPromotion(item);
                          //   }
                          // }

                          // NEW CODE WITH FIRST ORDER 
                          if (item.is_default) {
                              if (item.is_first_order && user?.total_orders === 0) {
                                if (!sessionStorage.getItem('promoId')) {
                                  discount.push(item);
                                  this.store.saveAcceptedPromotion(item);
                                }
                              } else if (!item.is_first_order) {
                                if (!sessionStorage.getItem('promoId')) {
                                  discount.push(item);
                                  this.store.saveAcceptedPromotion(item);
                                }
                              }
                            }
                          
                          else {
                            /**
                             * - NOT DEFAULT
                             * - USER HAVE TO ACCEPT DISCOUNT
                             * **/

                            /*** - COUNT USER PREVIOUS ORDERS * **/
                            if (item.is_first_order && (user && user.total_orders === 0)) {
                              discount.push(item);
                            }
                            if (item.is_first_order === false) {
                              discount.push(item);
                            }
                          }
                        }
                      }
                    }
                  } else {
                    /**
                     * - IF USER DID NOT SELECT PAYMENT METHOD YET!
                     * **/

                    /*
                      * - EITHER CASH OR CARD * CASH = 1; CARD = 2
                      * */

                     if (item.start_date !== null && item.end_date !== null) {
                      /**
                       * - IF START AND END DATE ASSIGNED
                       */


                      const start_date = new Date(item.start_date);
                      const end_date = new Date(item.end_date);
                      if (currentTime >= start_date && currentTime <= end_date) {

                        if (item.discount_available_time.length > 0) {
                          const dayName = currentTime.getDay();
                          const _times = item.discount_available_time.filter((book: any) => book.day_name === dayName);
                          if (_times.length > 0) {

                            const start_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].start_time));
                            const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].end_time));
                            // if (currentTime >= start_time && currentTime <= end_time || currentTime < start_time) {
                            if ((currentTime >= start_time && currentTime <= end_time) || ((currentTime >= start_time && convertedWhenTime >= start_time) && (currentTime <= end_time && convertedWhenTime <= end_time))) {
                              // if (item.is_default) {
                              //   /*** - COUNT USER PREVIOUS ORDERS * **/
                              //   if (item.is_first_order && !user) {
                              //     discount.push(item);
                              //     // default discount added directly
                              //     if (!sessionStorage.getItem('promoId')) {
                              //       this.store.saveAcceptedPromotion(item);
                              //     }
                              //     return
                              //   }

                              //   if (item.is_first_order && (user && user.total_orders === 0)) {
                              //     discount.push(item);
                              //     // default discount added directly
                              //     if (!sessionStorage.getItem('promoId')) {
                              //       this.store.saveAcceptedPromotion(item);
                              //     }
                              //     return
                              //   }
                              //   if (item.is_first_order === false) {
                              //     discount.push(item);
                              //     // default discount added directly
                              //     if (!sessionStorage.getItem('promoId')) {
                              //       this.store.saveAcceptedPromotion(item);
                              //     }
                              //     return
                              //   }
                              // } 
                              
                              // NEW CODE WITH FIRST ORDER 
                              if (item.is_default) {
                                if (item.is_first_order && !user) {
                                  discount.push(item);
                                  // default discount added directly
                                  if (!sessionStorage.getItem('promoId')) {
                                    this.store.saveAcceptedPromotion(item);
                                  }
                                  return
                                }
                                
                                  if (item.is_first_order && user?.total_orders === 0) {
                                    if (!sessionStorage.getItem('promoId')) {
                                      discount.push(item);
                                      this.store.saveAcceptedPromotion(item);
                                    }
                                  } else if (!item.is_first_order) {
                                    if (!sessionStorage.getItem('promoId')) {
                                      discount.push(item);
                                      this.store.saveAcceptedPromotion(item);
                                    }
                                  }
                                }

                              else {
                                /**
                                 * - NOT DEFAULT
                                 * - USER HAVE TO ACCEPT DISCOUNT
                                 * **/

                                /*** - COUNT USER PREVIOUS ORDERS * **/
                                if (item.is_first_order && (user && user.total_orders === 0)) {
                                  discount.push(item);
                                }
                                if (item.is_first_order === false) {

                                  discount.push(item);
                                }
                              }
                            }
                          } // end time compare
                        } else {
                          /**
                           * - NOT TIME GIVEN
                           * **/
                          // if (item.is_default) {
                          //   /*** - COUNT USER PREVIOUS ORDERS * **/
                          //   /*** - COUNT USER PREVIOUS ORDERS * **/
                          //   if (item.is_first_order && (user && user.total_orders === 0)) {
                          //     discount.push(item);
                          //   }
                          //   if (item.is_first_order === false) {
                          //     discount.push(item);
                          //   }
                          //   // default discount added directly
                          //   if (!sessionStorage.getItem('promoId')) {
                          //     this.store.saveAcceptedPromotion(item);
                          //   }
                          // }

                          // NEW CODE WITH FIRST ORDER 
                          if (item.is_default) {
                            if (item.is_first_order && user?.total_orders === 0) {
                              if (!sessionStorage.getItem('promoId')) {
                                discount.push(item);
                                this.store.saveAcceptedPromotion(item);
                              }
                            } else if (!item.is_first_order) {
                              if (!sessionStorage.getItem('promoId')) {
                                discount.push(item);
                                this.store.saveAcceptedPromotion(item);
                              }
                            }
                          }
                          
                          else {
                            /**
                             * - NOT DEFAULT * - USER HAVE TO ACCEPT DISCOUNT
                             * **/

                            /*** - COUNT USER PREVIOUS ORDERS * **/
                            if (item.is_first_order && (user && user.total_orders === 0)) {
                              discount.push(item);
                            }

                            if (item.is_first_order === false) {
                              discount.push(item);
                            }
                          }
                        }
                      }
                    } else {
                      /*
                        * - IF START AND END DATE NOT GIVEN.
                        * */
                       if (item.discount_available_time.length > 0) {
                        
                         const dayName = currentTime.getDay();
                         const _times = item.discount_available_time.filter((book: any) => book.day_name === dayName);
                         if (_times.length > 0) {
                           const start_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].start_time));
                           const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + _times[0].end_time));
                           // if (currentTime >= start_time && currentTime <= end_time || currentTime < start_time) {
                            if ((currentTime >= start_time && currentTime <= end_time) || ((currentTime >= start_time && convertedWhenTime >= start_time) && (currentTime <= end_time && convertedWhenTime <= end_time))) {
                            // if (item.is_default) {
                            //   /*** - COUNT USER PREVIOUS ORDERS * **/
                            //   /*** - COUNT USER PREVIOUS ORDERS * **/
                            //   if (item.is_first_order && (user && user.total_orders === 0)) {
                            //     discount.push(item);
                            //   }
                            //   if (item.is_first_order === false) {
                            //     discount.push(item);
                            //   }
                            //   // default discount added directly
                            //   if (!sessionStorage.getItem('promoId')) {
                            //     this.store.saveAcceptedPromotion(item);
                            //   }
                            // } 
                            // NEW CODE WITH FIRST ORDER 
                            if (item.is_default) {
                              if (item.is_first_order && user?.total_orders === 0) {
                                if (!sessionStorage.getItem('promoId')) {
                                  discount.push(item);
                                  this.store.saveAcceptedPromotion(item);
                                }
                              } else if (!item.is_first_order) {
                                if (!sessionStorage.getItem('promoId')) {
                                  discount.push(item);
                                  this.store.saveAcceptedPromotion(item);
                                }
                              }
                            }
                            else {
                              /**
                               * - NOT DEFAULT
                               * - USER HAVE TO ACCEPT DISCOUNT
                               * **/

                              /*** - COUNT USER PREVIOUS ORDERS * **/
                              if (item.is_first_order && (user && user.total_orders === 0)) {
                                discount.push(item);
                              }
                              if (item.is_first_order === false) {
                                discount.push(item);
                              }
                            }
                          }
                        } // end time compare
                      } else {
                        
                        // if (item.is_default) {
                        //   /**
                        //    * - COUNT USER PREVIOUS ORDERS
                        //    * **/
                        //   /*** - COUNT USER PREVIOUS ORDERS * **/
                        //   if (item.is_first_order && (user && user.total_orders === 0)) {
                        //     discount.push(item);
                        //   }
                        //   if (item.is_first_order === false) {
                        //     discount.push(item);
                        //   }
                        //   // default discount added directly
                        //   if (!sessionStorage.getItem('promoId')) {
                        //     this.store.saveAcceptedPromotion(item);
                        //   }
                        // } 

                        // NEW CODE WITH FIRST ORDER 
                        if (item.is_default) {
                          if (item.is_first_order && user?.total_orders === 0) {
                            if (!sessionStorage.getItem('promoId')) {
                              discount.push(item);
                              this.store.saveAcceptedPromotion(item);
                            }
                          } else if (!item.is_first_order) {
                            if (!sessionStorage.getItem('promoId')) {
                              discount.push(item);
                              this.store.saveAcceptedPromotion(item);
                            }
                          }
                        }
                        else {
                          /**
                           * - NOT DEFAULT
                           * - USER HAVE TO ACCEPT DISCOUNT
                           * **/

                          /*** - COUNT USER PREVIOUS ORDERS * **/
                          if (item.is_first_order && (user && user.total_orders === 0)) {
                            discount.push(item);
                          }
                          if (item.is_first_order === false) {
                            discount.push(item);
                          }
                        }
                      }
                    }
                  }
                }
              });
            }
          }
          const availableOffersDiscount = discount.concat(offers);
          resolve(availableOffersDiscount);
        }, 200);
      }
    });
  }

  convertToDate(timeStr: any, baseTimeStr?: any, baseDate: Date = new Date()) {
    const timeMinutes = this.parseTimeToMinutes(timeStr);
    if (timeMinutes === null) {
      return new Date(NaN);
    }

    const date = new Date(baseDate);
    const hours = Math.floor(timeMinutes / 60);
    const minutes = timeMinutes % 60;
    date.setHours(hours, minutes, 0, 0);

    if (baseTimeStr) {
      const baseMinutes = this.parseTimeToMinutes(baseTimeStr);
      if (baseMinutes !== null && timeMinutes < baseMinutes) {
        date.setDate(date.getDate() + 1);
      }
    }

    return date;
  }

  getASAPTime(deliveryTime: any) {
    const currentTime = new Date();
    return this.changeTimeFormat(new Date(currentTime.getTime() + Number(deliveryTime) * 60000));
  }

  stringTitleCase(str: any) {
    return str.toLowerCase().split(' ').map(function (word: any) {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }

  goToWebLink(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      var url = String(data).replace(/^(https?:\/\/)?(www\.)?/, 'http://');
      window.open(url, '_blank',);
    }
  }

  generateCartHashKey(dishData: any) {
    let dish_extra_id = '';
    if (dishData['dish_extra']) {
      dishData['dish_extra'].forEach((grp: any) => {
        dish_extra_id = dish_extra_id.concat(grp['_id']);
        grp['option'].forEach((opt: any) => {
          dish_extra_id = dish_extra_id.concat(opt['_id']);
        });
      });
    }
    const checksum_data = {
      _id: dishData['_id'],
      dish_id: dishData['dish_id'],
      dish_instruction: dishData['dish_instruction'].trim().toLowerCase(),
      dish_extra_id: dish_extra_id
    }
    const md5 = new Md5();
    let checksum = md5.appendStr(JSON.stringify(checksum_data)).end();
    return checksum;
  }

  generateCartDataHashKey(cartData: any, _for?: string) {
    const md5 = new Md5();
    let checksum = md5.appendStr(JSON.stringify(cartData)).end();
    if (this.platformId === 'browser') {
      if (_for && _for === 'reservation-menu') {
        sessionStorage.setItem('generated_res_cart_data', JSON.stringify(checksum));
      } else {
        sessionStorage.setItem('generated_cart_data', JSON.stringify(checksum));
      }
    }
  }

  getAvailablePromotions(subTotalExcludeOffer: any, discountsData: any, offersData: any) {
    return new Promise((resolve) => {
      let eligiblePromotionList: any[] = [];
      this.checkPromotionEligibility(subTotalExcludeOffer, discountsData, offersData).then((result: any) => {
        result.forEach((item: any) => {
          eligiblePromotionList.push(item);
        });
        const currentTime = new Date();

        const filteredList = eligiblePromotionList.filter((item: any) => {
          const start_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + item.start_time));
          const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + item.end_time));
          return ((currentTime >= start_time && currentTime <= end_time) && item.is_active);
        })
        this.store.saveAvailablePromotion(filteredList);
        resolve('check & save');
      });
    });
  }

  getAcceptedDiscount(subTotalExcludeOffer: any, AcceptedData: any) {
    return new Promise((resolve) => {
      /** its_type=1=discount, its_type=2=offer **/
      let selected_policy: any;
      let selected_payment: any;
      this.store.selected_policy.subscribe((result: any) => {
        if (result && result['policy']) {
          selected_policy = result['policy'] === 'COLLECTION' ? 1 : 2;
        } else {
          selected_policy = 2;
        }
      });
      this.store.paymentMethod.subscribe((result: any) => {
        if (result && result['is_active']) {
          // selected_payment = result['paymentType'] === 'CARD' ? 2 : 1
          if(result['paymentType'] === 'CARD'){
            selected_payment = 2;
          }
          if(result['paymentType'] === 'CASH'){
            selected_payment = 1;
          }
          if(result['paymentType'] === 'Pay by card on delivery/collection' || result['paymentType']?.includes('Pay by card')){
            selected_payment = 3;
          }
        }
      });
      switch (AcceptedData?.its_type) {
        case 1:
          if(AcceptedData){
            const currentTime = new Date()
            const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + AcceptedData.end_time));
            if ((currentTime >= end_time)){
              this.store.saveAcceptedPromotion({});
              return
            }
          }
          if (
            (selected_policy === Number(AcceptedData.discount_eligible_for) || Number(AcceptedData.discount_eligible_for) === 0)
            && selected_payment
            && (AcceptedData.eligible_payment_methods === selected_payment || AcceptedData.eligible_payment_methods === 0)
            && subTotalExcludeOffer >= AcceptedData.discount_eligible_amount
          ) {
            /**
             * SET ACCEPTED DISCOUNT DATA
             * Eligible policy either collection/delivery or both
             * col=1, del =2, both=0,
             * Eligible payment method selected
             * cash=1, card 2, both 0
            **/
           resolve(AcceptedData);
          } else if (
            (selected_policy === Number(AcceptedData.discount_eligible_for) || Number(AcceptedData.discount_eligible_for) === 0)
            && !selected_payment
            && subTotalExcludeOffer >= AcceptedData.discount_eligible_amount
          ) {
            /**-----SET ACCEPTED DISCOUNT DATA UNTIL USER SELECT PAYMENT METHOD-----**/
            resolve(AcceptedData);
          } else if (
            (selected_policy === Number(AcceptedData.discount_eligible_for) || Number(AcceptedData.discount_eligible_for) === 0)
            && selected_payment
            && (AcceptedData.eligible_payment_methods !== selected_payment || AcceptedData.eligible_payment_methods !== 0)
            && subTotalExcludeOffer < AcceptedData.discount_eligible_amount
          ) {
            /**
             * RESET ACCEPTED DISCOUNT DATA
             * SELECTED PAYMENT METHOD NOT ELIBIBLE
            **/
            this.store.saveAcceptedPromotion({});
          } else if (
            (selected_policy !== Number(AcceptedData.discount_eligible_for) || Number(AcceptedData.discount_eligible_for) !== 0)
            && !selected_payment
            || subTotalExcludeOffer < AcceptedData.discount_eligible_amount
          ) {
            /**
             * RESET ACCEPTED DISCOUNT DATA
             * SELECTED policy NOT ELIBIBLE
            **/
            this.store.saveAcceptedPromotion({});
          } else if (
            (selected_policy !== Number(AcceptedData.discount_eligible_for) || Number(AcceptedData.discount_eligible_for) !== 0)
            && selected_payment
            && (AcceptedData.eligible_payment_methods !== selected_payment || AcceptedData.eligible_payment_methods !== 0)
            || subTotalExcludeOffer < AcceptedData.discount_eligible_amount
          ) {
            /**
             * RESET ACCEPTED DISCOUNT DATA
             * SELECTED PAYMENT METHOD NOT ELIBIBLE
            **/
            this.store.saveAcceptedPromotion({});
          } else if (
            subTotalExcludeOffer < AcceptedData.discount_eligible_amount
          ) {
            this.store.saveAcceptedPromotion({});
          }
          break;

        case 2:
          if(AcceptedData){
            const currentTime = new Date()
            const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + AcceptedData.end_time));
            if ((currentTime >= end_time)){
              this.store.saveAcceptedPromotion({});
              return
            }
          }
          
          if (
            (selected_policy === Number(AcceptedData.offer_eligible_for) || Number(AcceptedData.offer_eligible_for) === 0)
            && selected_payment
            && (AcceptedData.eligible_payment_methods === selected_payment || AcceptedData.eligible_payment_methods === 0)
            && subTotalExcludeOffer >= AcceptedData.offer_eligible_amount
          ) {
            /**
             * SET ACCEPTED DISCOUNT DATA
             * Eligible policy either collection/delivery or both
             * col=1, del =2, both=0,
             * Eligible payment method selected
             * cash=1, card 2, both 0
            **/
            resolve(AcceptedData);
          } else if (
            (selected_policy === Number(AcceptedData.offer_eligible_for) || Number(AcceptedData.offer_eligible_for) === 0)
            && !selected_payment
            && subTotalExcludeOffer >= AcceptedData.offer_eligible_amount
          ) {
            /**SET ACCEPTED DISCOUNT DATA UNTIL USER SELECT PAYMENT METHOD**/
            resolve(AcceptedData);
          } else if (
            (selected_policy === Number(AcceptedData.offer_eligible_for) || Number(AcceptedData.offer_eligible_for) === 0)
            && selected_payment
            && (AcceptedData.eligible_payment_methods !== selected_payment || AcceptedData.eligible_payment_methods !== 0)
            || subTotalExcludeOffer < AcceptedData.offer_eligible_amount
          ) {
            /**
             * RESET ACCEPTED DISCOUNT DATA
             * SELECTED PAYMENT METHOD NOT ELIBIBLE
            **/
            this.store.saveAcceptedPromotion({});
          } else if (
            (selected_policy !== Number(AcceptedData.offer_eligible_for) || Number(AcceptedData.offer_eligible_for) !== 0)
            && !selected_payment
            || subTotalExcludeOffer < AcceptedData.offer_eligible_amount
          ) {
            /**
             * RESET ACCEPTED DISCOUNT DATA
             * SELECTED policy NOT ELIBIBLE
            **/
            this.store.saveAcceptedPromotion({});
          } else if (
            (selected_policy !== Number(AcceptedData.offer_eligible_for) || Number(AcceptedData.offer_eligible_for) !== 0)
            && selected_payment
            && (AcceptedData.eligible_payment_methods !== selected_payment || AcceptedData.eligible_payment_methods !== 0)
            || subTotalExcludeOffer < AcceptedData.offer_eligible_amount
          ) {
            /**
             * RESET ACCEPTED DISCOUNT DATA
             * SELECTED PAYMENT METHOD NOT ELIBIBLE
            **/
            this.store.saveAcceptedPromotion({});
          } else if (
            subTotalExcludeOffer < AcceptedData.offer_eligible_amount
          ) {
            this.store.saveAcceptedPromotion({});
          }
          break;

        case 3:
        if(AcceptedData){
          const currentTime = new Date()
          const end_time = new Date(Date.parse(currentTime.getFullYear() + '/' + (currentTime.getMonth() + 1) + '/' + currentTime.getDate() + ' ' + AcceptedData.end_time));
          if ((currentTime >= end_time)){
            this.store.saveAcceptedPromotion({});
            return
          }
        }
        
        if (
          (selected_policy === Number(AcceptedData.offer_eligible_for) || Number(AcceptedData.offer_eligible_for) === 0)
          && selected_payment
          && (AcceptedData.eligible_payment_methods === selected_payment || AcceptedData.eligible_payment_methods === 0)
          && subTotalExcludeOffer >= AcceptedData.offer_eligible_amount
        ) {
          /**
           * SET ACCEPTED DISCOUNT DATA
           * Eligible policy either collection/delivery or both
           * col=1, del =2, both=0,
           * Eligible payment method selected
           * cash=1, card 2, both 0
          **/
          resolve(AcceptedData);
        } else if (
          (selected_policy === Number(AcceptedData.offer_eligible_for) || Number(AcceptedData.offer_eligible_for) === 0)
          && !selected_payment
          && subTotalExcludeOffer >= AcceptedData.offer_eligible_amount
        ) {
          /**SET ACCEPTED DISCOUNT DATA UNTIL USER SELECT PAYMENT METHOD**/
          resolve(AcceptedData);
        } else if (
          (selected_policy === Number(AcceptedData.offer_eligible_for) || Number(AcceptedData.offer_eligible_for) === 0)
          && selected_payment
          && (AcceptedData.eligible_payment_methods !== selected_payment || AcceptedData.eligible_payment_methods !== 0)
          || subTotalExcludeOffer < AcceptedData.offer_eligible_amount
        ) {
          /**
           * RESET ACCEPTED DISCOUNT DATA
           * SELECTED PAYMENT METHOD NOT ELIBIBLE
          **/
          this.store.saveAcceptedPromotion({});
        } else if (
          (selected_policy !== Number(AcceptedData.offer_eligible_for) || Number(AcceptedData.offer_eligible_for) !== 0)
          && !selected_payment
          || subTotalExcludeOffer < AcceptedData.offer_eligible_amount
        ) {
          /**
           * RESET ACCEPTED DISCOUNT DATA
           * SELECTED policy NOT ELIBIBLE
          **/
          this.store.saveAcceptedPromotion({});
        } else if (
          (selected_policy !== Number(AcceptedData.offer_eligible_for) || Number(AcceptedData.offer_eligible_for) !== 0)
          && selected_payment
          && (AcceptedData.eligible_payment_methods !== selected_payment || AcceptedData.eligible_payment_methods !== 0)
          || subTotalExcludeOffer < AcceptedData.offer_eligible_amount
        ) {
          /**
           * RESET ACCEPTED DISCOUNT DATA
           * SELECTED PAYMENT METHOD NOT ELIBIBLE
          **/
          this.store.saveAcceptedPromotion({});
        } else if (
          subTotalExcludeOffer < AcceptedData.offer_eligible_amount
        ) {
          this.store.saveAcceptedPromotion({});
        }
        break;

      }
    });
  }

  public calculateDishVat(dishData: any, discountData: any, totalDish: number) {
    if (!totalDish || totalDish <= 0) return;
    // check vat is enable or not
    if (!this.restaurantData || !this.restaurantData['is_vat_enable']) return;
    // check has discout or not
    // discount amount deduction from dish vat
    let deductedAmount: number = 0;
    if (discountData['amount'] && discountData['amount'] > 0) {
      if (discountData['type'] === 1) {// dish vat deduction by percentage
        deductedAmount = Number(((dishData['unit_price'] * discountData['rate']) / 100).toFixed(4));
      } else {// dish vat deduction by fixed
        deductedAmount = discountData['amount'] / totalDish;
      }
    }
    // declare the property
    let price: number = Number((((dishData['unit_price'] - deductedAmount)) - dishData['package_price']) * dishData['quantity']);
    let vatType: string = this.restaurantData.is_vat_included ? 'include' : 'exclude';
    let vatRate: number = dishData['vat_rate'] !== null ? dishData['vat_rate'] : this.findUpperLabelVatRate(dishData['category_id']);

    // console.log(`vat rate:${vatRate}`);
    // vat formula
    // console.log(dishData['vat_rate'], vatType, vatRate);
    let includeFormula = Number(((price / ((100 + vatRate) / 100)) * (vatRate / 100)).toFixed(4));
    let excludeFormula = Number(((price * vatRate) / 100).toFixed(4));
    let vatableAmount: number = vatType === 'include' ? Number(includeFormula.toFixed(4)) : Number(excludeFormula.toFixed(4));
    return { vat_amount: vatableAmount, vat_type: vatType, vat_rate: vatRate };
  }

  findUpperLabelVatRate(categoryId: string): number {
    let vat_rate: number = 0;
    const dishCategory = this.restaurantDish?.flatMap((cuisine: any) => cuisine?.dish_categories).find((category: any) => category?._id === categoryId);
    if (dishCategory && dishCategory.vat_rate) {
      return vat_rate = dishCategory.vat_rate;
    } else if (this.restaurantData.vat_rate) {
      return vat_rate = this.restaurantData.vat_rate;
    }
    return vat_rate;
  }

  public roundUp(num: number) {
    // console.log("roundUp"+num);
    const roundedNum = Math.round(num * 100) / 100; // round to two decimal places
    const decimalPart = roundedNum - Math.trunc(roundedNum); // get the decimal part
    if (decimalPart >= 0.005) {
      return Math.ceil(roundedNum * 100) / 100; // round up if third decimal place is 5 or greater than 5
    } else {
      return roundedNum;
    }
  }

  showSuccessToast(msg: any) {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: `${msg} successfully`,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        popup: 'custom-toast-background',
        icon: 'custom-toast-icon',
        title: 'custom-toast-title'
      },
      onBeforeOpen: (toast) => {
        // Ensure all animations and transitions are disabled
        toast.style.animation = 'none';
        toast.style.transition = 'none';
        toast.style.opacity = '1';

        // Add custom animation to the icon
        const icon = toast.querySelector('.swal2-icon.swal2-success');
        if (icon) {
          icon.classList.add('custom-icon-animation');
        }
      }
    });
  }

  private resolveScheduleForTimeContext(
    schedule: any,
    currentTime: Date = new Date(),
    midnightCutoffMinutes: number = 4 * 60
  ): { schedule: any | null; baseDate: Date } {
    const baseDate = new Date(currentTime);
    if (!schedule || !Array.isArray(schedule) || schedule.length === 0) {
      return { schedule: null, baseDate };
    }

    const hasDayOfWeek = schedule.some((item: any) => item?.dayOfWeek !== undefined && item?.dayOfWeek !== null);
    if (!hasDayOfWeek) {
      return { schedule: schedule[0], baseDate };
    }

    const todayDayOfWeek = currentTime.getDay();
    const prevDayOfWeek = (todayDayOfWeek + 6) % 7;
    const todaySchedule = schedule.find((day: any) => Number(day?.dayOfWeek) === todayDayOfWeek) || null;
    const prevSchedule = schedule.find((day: any) => Number(day?.dayOfWeek) === prevDayOfWeek) || null;

    const currentMinutes = currentTime.getHours() * 60 + currentTime.getMinutes();
    const isBeforeCutoff = currentMinutes < midnightCutoffMinutes;

    if (isBeforeCutoff && prevSchedule?.isMidNightShift) {
      const prevBaseDate = new Date(currentTime);
      prevBaseDate.setDate(prevBaseDate.getDate() - 1);
      return { schedule: prevSchedule, baseDate: prevBaseDate };
    }

    return { schedule: todaySchedule, baseDate };
  }

  getScheduleDisplayLabel(
    schedule: any,
    currentTime: Date = new Date(),
    midnightCutoffMinutes: number = 4 * 60
  ): string {
    const resolved = this.resolveScheduleForTimeContext(schedule, currentTime, midnightCutoffMinutes);
    const todaysSchedule = resolved.schedule;
    if (!todaysSchedule) {
      return 'Closed today';
    }

    if (todaysSchedule?.status !== 'open') {
      return 'Closed today';
    }

    const label = typeof todaysSchedule?.label === 'string' ? todaysSchedule.label.trim() : '';
    if (label) {
      return label;
    }

    const shifts = Array.isArray(todaysSchedule.shift)
      ? todaysSchedule.shift.filter((shift: any) =>
        shift?.collection?.isActive || shift?.delivery?.isActive || shift?.reservation?.isActive
      )
      : [];

    if (shifts.length === 0) {
      return 'Closed today';
    }

    const shiftStrings = shifts
      .map((shift: any) => {
        if (!shift?.openingTime || !shift?.closingTime) return null;
        return `${this.convertTime24to12(shift.openingTime)} - ${this.convertTime24to12(shift.closingTime)}`;
      })
      .filter(Boolean);

    return shiftStrings.length > 0 ? shiftStrings.join(', ') : 'Closed today';
  }
  getOrderTimeDate(timeStr: any, policy?: string, restaurantStatus?: string, now: Date = new Date()): Date {
    let schedule: any;
    if (isPlatformBrowser(this.platformId)) {
      const scheduleStr = sessionStorage.getItem('todaysSchedule');
      schedule = scheduleStr ? JSON.parse(scheduleStr) : null;
    }
    const baseTime = policy === 'DELIVERY'
      ? schedule?.delivery_startTime || schedule?.preOrderDeliveryTimes?.[0]
      : schedule?.collection_startTime || schedule?.preOrderCollecitonTimes?.[0];
    const baseDate = new Date(now);
    if (baseTime && restaurantStatus === 'OPEN' && now.getHours() < 4 &&
        this.convertToDate(baseTime, baseTime, now) > now) {
      baseDate.setDate(baseDate.getDate() - 1);
    }
    return this.convertToDate(timeStr, baseTime, baseDate);
  }

  private parseTimeToMinutes(timeStr: any): number | null {
    if (!timeStr) {
      return null;
    }

    const trimmed = String(timeStr).trim();
    if (!trimmed) {
      return null;
    }

    const parts = trimmed.split(/\s+/);
    const timePart = parts[0];
    const [hoursStr, minutesStr] = timePart.split(':');

    let hours = Number(hoursStr);
    const minutes = Number(minutesStr);

    if (parts.length > 1) {
      const modifier = parts[1].toUpperCase();
      if (modifier === 'PM' && hours !== 12) {
        hours += 12;
      }
      if (modifier === 'AM' && hours === 12) {
        hours = 0;
      }
    }

    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
      return null;
    }

    return (hours * 60) + minutes;
  }

}
